import {SmsLogHdsList} from "./SmsLogHdsList";
import {SmsLogHdsEdit} from "./SmsLogHdsEdit";
import {SmsLogHdsCreate} from "./SmsLogHdsCreate";

export default {
    list: SmsLogHdsList,
    create: SmsLogHdsCreate,
    edit: SmsLogHdsEdit
};
